// ----------------------------------------------------------------------

export default function Grid2() {
  return {
    MuiGrid: {
      styleOverrides: {},
    },
  };
}
